import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "portal" }
const _hoisted_2 = {
  key: 0,
  class: "scroll"
}
const _hoisted_3 = { class: "topbar" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "selectionbar" }
const _hoisted_7 = { class: "packages" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "heroimg" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "content flex" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = {
  key: 0,
  class: "gg-check blue"
}
const _hoisted_14 = { class: "value" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "flex v-center center main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loader_display = _resolveComponent("loader-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "homebutton",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.home()))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "gg-chevron-left" }, null, -1),
              _createElementVNode("div", null, "Home", -1)
            ])),
            (_ctx.logourl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", { src: _ctx.logourl }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.hasActivities)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({ selected: !_ctx.isPackage, item: true }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setView(_ctx.PackageViewMode.INDIVIDUAL)))
                }, "Activities", 2))
              : _createCommentVNode("", true),
            (_ctx.hasPackages)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass({ selected: _ctx.isPackage, item: true }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setView(_ctx.PackageViewMode.PACKAGE)))
                }, "Packages", 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: item.OrderEntityKey ?? item.OrderPackageKey ?? 0,
                onClick: ($event: any) => (_ctx.navTo(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _ctx.getImage(item)
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.Name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(item), (str) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "checkitem flex",
                      key: str
                    }, [
                      (str.startsWith('*'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(str.replaceAll('*', '')), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "fromprice",
                    innerHTML: _ctx.getFromString(item)
                  }, null, 8, _hoisted_15)
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "chevron" }, [
                  _createElementVNode("div", { class: "gg-chevron-right blue" })
                ], -1))
              ], 8, _hoisted_8))
            }), 128))
          ]),
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_loader_display)
        ]))
  ]))
}